<template>
  <div class="app-container">
    <el-form v-show="showSearch" ref="queryForm" :model="queryParams" size="small" :inline="true" label-width="100px">
      <dt-form-item
        label="行动规则名称"
        inputType="input"
        v-model="queryParams.logicName"
        :options="statusArr"
        :componentAttr="{
          clearable: true,
          valueKey: 'label',
          placeholder: '请输入'
        }"
        @clear="getList()"
      >
      </dt-form-item>
      <dt-form-item
        :label="searchParamFormKey.label"
        :inputType="searchParamFormKey.type"
        v-model="queryParams.formKey"
        :propKey="searchParamFormKey.propKey"
        :options="searchParamFormKey.options"
        :componentAttr="searchParamFormKey.attrs"
        :valueRepeat="searchParamFormKey.valueRepeat"
        @clear="getList()"
      >
      </dt-form-item>

      <dt-form-item
        label="状态"
        inputType="select"
        v-model="queryParams.status"
        :options="statusArr"
        :componentAttr="{
          clearable: true,
          valueKey: 'label'
        }"
        @clear="getList()"
      >
      </dt-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"> 搜索 </el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"> 重置 </el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8" type="flex" justify="end">
      <el-col :span="1.5">
        <el-button v-permission="['workOrderRule_create']" type="primary" size="small" @click="handleToRuleDetail">
          新建规则
        </el-button>
      </el-col>
    </el-row>

    <el-table style="margin-top: 10px" v-loading="loading" :data="workOrderList">
      <el-table-column label="规则名称" align="center" prop="logicName" />
      <el-table-column label="触发问卷" align="center" prop="formName" />
      <el-table-column label="状态" align="center" prop="id" width="100px">
        <template slot-scope="{ row }">
          <el-tag :type="row.status ? 'success' : 'danger'" effect="dark">
            {{ row.status == 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
      <el-table-column label="更新时间" align="center" prop="updateTime"></el-table-column>
      <el-table-column
        label="操作"
        v-permission="['workOrderRule_enable', 'workOrderRule_disable', 'workOrderRule_update']"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="{ row }">
          <el-button
            v-permission="['workOrderRule_enable', 'workOrderRule_disable']"
            size="mini"
            type="text"
            @click="handleDelete(row)"
          >
            <span :class="row.status == 1 ? 'success' : 'danger'">{{ row.status == 1 ? '禁用' : '启用' }}</span>
          </el-button>
          <el-button v-permission="['workOrderRule_update']" size="mini" type="text" @click="handleToRuleDetail(row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.currentPage"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { getWorkOrderLogicList, enableWorkOrderLogic, disableWorkOrderLogic } from '@/api/workOrder/rule'
import Pagination from '@/components/Pagination'
import DtFormItem from '@/components/DtFormItem'
// import OrderOperator from "./components/OrderOperator"
import Treeselect from '@riophae/vue-treeselect' // 使用文档：https://vue-treeselect.js.org/
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { getAllShopList } from '@/api/project/data'
import { tree2flatHelp } from '@/utils/flat2tree'
import { searchParamFormKey } from '../input'

let searchParams = null
export default {
  name: 'User',
  components: { Pagination, Treeselect, DtFormItem },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      shopOptions: [],
      multipleSelection: [],
      datePicker: ['beginDateTime', 'endDateTime'],
      searchParamFormKey,
      statusArr: [
        {
          value: 0,
          label: '禁用'
        },
        {
          value: 1,
          label: '启用'
        }
      ],
      // 按钮loading
      buttonLoading: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      workOrderList: [],
      // 查询参数
      queryParams: {
        currentPage: 1,
        pageSize: 20,
        formKey: '',
        status: '',
        logicName: ''
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    //  清空搜索项
    if (from.path !== '/workOrder/rule/detail') {
      searchParams = null
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    searchParams = this.queryParams
    next()
  },
  created() {
    // 搜索缓存
    searchParams && (this.queryParams = searchParams)
    this.getList()
    this.getAllShopList()
  },
  methods: {
    // 查询门店组织
    async getAllShopList() {
      const { data } = await getAllShopList()
      this.shopOptions = data
    },
    /** 查询列表 */
    async getList() {
      try {
        this.loading = true
        const { data } = await getWorkOrderLogicList(this.queryParams)
        this.workOrderList = data.records
        this.total = data.total
      } finally {
        this.loading = false
      }
    },
    handleCloseTree(item) {
      console.log({ item })
      this.form.shopCodes = item
    },
    handleSelect(item) {
      console.log({ handleSelect: item })
    },
    handleDeselect(item) {
      console.log({ handleDeselect: item })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.shopCode = []
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.currentPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      const { queryParams } = this
      const queryDefault = {
        formKey: '',
        status: '',
        logicName: ''
      }
      this.queryParams = { ...queryParams, ...queryDefault }
      this.resetForm('queryForm')
      this.handleQuery()
    },
    /** 启用/禁用按钮操作 */
    handleDelete(row) {
      const ruleId = row.id
      this.$confirm(`确认${row.status ? '禁用' : '启用'}该行动规则吗？`)
        .then(() => {
          this.loading = true
          // 0.禁用,1.启用
          const fn = row.status ? disableWorkOrderLogic : enableWorkOrderLogic
          return fn(ruleId)
        })
        .then(() => {
          this.loading = false
          this.msgSuccess('操作成功')
          this.getList()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleToRuleDetail(row = null) {
      this.$router.push({
        path: `/workOrder/rule/detail`,
        query: { id: row ? row.id : '' }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// .app-container {
//   overflow-y: auto;
// }
.is-error {
  margin-bottom: 32px;
}
.success {
  color: #67c23a;
}
.danger {
  color: #f56c6c;
}
</style>
